"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupByValuesType = exports.isGroupByDatasourceConfigRequest = exports.isGroupByDatasourceConfig = void 0;
const isGroupByDatasourceConfig = (cfg) => {
    return (cfg !== null &&
        'group_by' in cfg &&
        'values' in cfg &&
        cfg.group_by.length !== 0 &&
        cfg.group_by[0]['source_column_id'] !== undefined &&
        cfg.group_by[0]['groupby_column_id'] !== undefined);
};
exports.isGroupByDatasourceConfig = isGroupByDatasourceConfig;
const isGroupByDatasourceConfigRequest = (cfg) => {
    return 'group_by' in cfg && 'values' in cfg;
};
exports.isGroupByDatasourceConfigRequest = isGroupByDatasourceConfigRequest;
var GroupByValuesType;
(function (GroupByValuesType) {
    GroupByValuesType["SUM"] = "sum";
    GroupByValuesType["AVG"] = "avg";
    GroupByValuesType["COUNT"] = "count";
    GroupByValuesType["MIN"] = "min";
    GroupByValuesType["MAX"] = "max";
    GroupByValuesType["JSON_ARRAY_AGG"] = "json_arrayagg";
})(GroupByValuesType = exports.GroupByValuesType || (exports.GroupByValuesType = {}));
